import GraniteError from 'granite-admin/utils/granite-error';
import { resetAuthToken, resetSsoLogin } from 'granite-admin/utils/auth-singleton';
function removeAuthToken() {
  try {
    resetAuthToken();
    resetSsoLogin();
  } catch (error) {
    throw new GraniteError(error);
  }
}
export { removeAuthToken };